import { container } from 'tsyringe';
import { viewModelMetadata } from '../metadata/ViewModelMetadata';
export class ViewModelContainerManager {
    constructor(ViewModel) {
        this.ViewModel = ViewModel;
        this.RootViewModel =
            viewModelMetadata.getParentViewModel(this.ViewModel) || this.ViewModel;
    }
    exists() {
        return ViewModelContainerManager.containerMap.has(this.RootViewModel);
    }
    resolveViewModel() {
        if (this.exists()) {
            const container = ViewModelContainerManager.containerMap.get(this.RootViewModel);
            return container.resolve(this.ViewModel);
        }
        const childContainer = container.createChildContainer();
        ViewModelContainerManager.containerMap.set(this.ViewModel, childContainer);
        return childContainer.resolve(this.ViewModel);
    }
    destroy() {
        if (!this.exists()) {
            return;
        }
        const container = ViewModelContainerManager.containerMap.get(this.RootViewModel);
        if (!container) {
            return;
        }
        if (this.RootViewModel !== this.ViewModel) {
            return;
        }
        // Clear instances
        container.clearInstances();
        // Clear registrations
        container.reset();
        // All instances created by the container will automatically be disposed of when the container is disposed
        container.dispose();
        ViewModelContainerManager.containerMap.delete(this.RootViewModel);
    }
}
ViewModelContainerManager.containerMap = new Map();
